export default __webpack_public_path__ + "static/media/linkedin.46f304ad.svg";